import React from 'react';
// import { HiMiniQuestionMarkCircle } from 'react-icons/hi2';
import { SwitchToggle } from '@components';
import { DistrictDatasetOptions, viewDataOptions } from '@mockData';
import { HousingOptionCardProps } from '@interface';

export const HousingOptionsCard: React.FC<HousingOptionCardProps> = ({
	selectedHousingType,
	handleHousnigViewChange,
	housingOptions,
	thresholds,
	handleThresholdChange,
	properties,
	dataInterval,
	handleDataIntervalChange,
	filterType,
	setFilterType,
	toggleStates,
	handleToggle,
}) => {
	// const questonMarkClass =	'h-6 w-6 text-[#324B69] hover:text-[#b9b8b8] cursor-pointer';

	const handleInputChange = (
		e: React.ChangeEvent<HTMLInputElement>,
		datasetId: string
	) => {
		e.stopPropagation();
		const value = parseInt(e.target.value);
		handleThresholdChange(datasetId, value);
	};

	return (
		<div className="px-4 max-w-4xl text-[#324B69]">
			<div className="my-[30px]">
				<div className="mb-[.5rem]">
					<div className="flex items-center gap-2">
						<span className="font-bold">HOUSING TYPE:</span>
						{/* <HiMiniQuestionMarkCircle className={questonMarkClass} /> */}
					</div>
				</div>
				<div>
					{housingOptions.map((option) => (
						<div
							key={option.value}
							className="flex items-center  gap-x-2 cursor-pointer hover:underline mb-[5px]"
							onClick={() => handleHousnigViewChange(option.label)}
						>
							<input
								type="radio"
								id={option.value}
								name="housingType"
								value={option.label}
								checked={selectedHousingType === option.label}
								className="w-4 h-4 "
							/>
							<label
								htmlFor={option.value}
								className="flex items-center gap-2 text-[14px] cursor-pointer"
							>
								<span>{option.label}</span>

								{option.tooltip && (
									<>
										<span className="">({option.percentage}%)</span>
										{/* <HiMiniQuestionMarkCircle className={questonMarkClass} /> */}
									</>
								)}
							</label>
						</div>
					))}
				</div>
			</div>
			<div className="mb-4">
				<div className="flex items-center justify-between gap-2 mb-4 ">
					<span className="font-bold text-[#324B69]">DATASETS:</span>
					<div className="flex items-center gap-2">
						<div className="flex items-center border rounded">
							<button
								className={`px-2 py-1 hover:shadow-stormy-night  min-w-12 ${filterType === 'AND' ? 'bg-[#324B69] text-white' : 'bg-white'}`}
								onClick={() => setFilterType('AND')}
							>
								AND
							</button>
							<button
								className={`px-2 py-1 min-w-12  hover:shadow-stormy-night ${filterType === 'OR' ? 'bg-[#324B69] text-white' : 'bg-white'}`}
								onClick={() => setFilterType('OR')}
							>
								OR
							</button>
						</div>
						<button className="text-blue-600">
							{/* <HiMiniQuestionMarkCircle className={questonMarkClass} /> */}
						</button>
					</div>
				</div>

				<div className="space-y-4">
					{DistrictDatasetOptions.map((dataset) => (
						<div key={dataset.id} className="space-y-1">
							<div className="flex items-center justify-between">
								<div className="flex items-center gap-2 text-[16px]">
									<span className="font-bold">{dataset.label}</span>
									{dataset.tooltip && (
										<button className="text-blue-600">
											{/* <HiMiniQuestionMarkCircle className={questonMarkClass} /> */}
										</button>
									)}
								</div>
								<SwitchToggle
									checked={toggleStates[dataset.id] || false}
									onCheckedChange={() => handleToggle(dataset.id)}
								/>
							</div>
							<p className="text-sm text-gray-600 pr-[40px] mb-[20px]">
								{
									<span className="flex-col text-[14px] justify-start items-center ">
										There are {properties[dataset.id]} properties with at least
										{toggleStates[dataset.id] && (
											<>
												<br />
												<input
													type="number"
													value={thresholds[dataset.id] || 0}
													// onChange={(e) =>
													// 	handleThresholdChange(
													// 		dataset.id,
													// 		parseInt(e.target.value)
													// 	)
													// }
													onChange={(e) => handleInputChange(e, dataset.id)}
													onClick={(e) => e.stopPropagation()}
													className="w-16 px-[.5rem] py-[.25rem] border border-x-0 border-t-0  max-w-[60px]  font-semibold text-[16px] leading-normal mr-[5px] outline-none border-b-[#e1e1e1]"
												/>
											</>
										)}
										{!toggleStates[dataset.id] && ` ${thresholds[dataset.id]} `}
										{dataset.unit}
									</span>
								}
							</p>
						</div>
					))}
				</div>
			</div>

			<div className="my-[30px]">
				<div className="mb-[.5rem]">
					<div className="flex items-center gap-2">
						<span className="font-bold">VIEW DATA FROM:</span>
						{/* <HiMiniQuestionMarkCircle className={questonMarkClass} /> */}
					</div>
				</div>
				<div>
					{viewDataOptions.map((option) => (
						<div
							key={option.value}
							className="flex items-center  gap-x-2 cursor-pointer hover:underline mb-[5px]"
							onClick={() => handleDataIntervalChange(option.value)}
						>
							<input
								type="radio"
								id={option.value}
								name="viewData"
								value={option.value}
								checked={dataInterval === option.value}
								className="w-4 h-4 "
							/>
							<label
								htmlFor={option.value}
								className="flex items-center gap-2 text-[14px] cursor-pointer"
							>
								<span>{option.label}</span>
							</label>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
